<div style="display: flex;margin-left: -13px;margin-top: -30px;">
    <div style="margin-right: 10px;margin-top: 10;">
    

      <div>
        <span style="font-size: 12px; font-weight: 500; color: rgba(255,255,255,0.7);  ">
            Threads
          </span>
          
        <div style="display: flex; justify-content: space-between;">
            <div style="flex: 1;margin-right: 10px;">    
                <mat-form-field >
                    <mat-label> </mat-label>
                    <input matInput placeholder="0" type="number" [(ngModel)]="viewModel.threads">
                </mat-form-field>
            </div>  
        </div>
      </div>
    </div>

    <div style="margin-right: 10px;margin-top: 10;">
        <div>
            <span style="font-size: 12px; font-weight: 500; color: rgba(255,255,255,0.7);  ">
                Raw Data Defaults
            </span>
            <div style="display: flex; justify-content: space-between;">
                <div style="flex: 1;margin-right: 10px;">    
                    <mat-form-field >
                        <mat-label>Timestamp when empty</mat-label>
                        <input matInput placeholder="1970-01-01 00:00:00" type="text" [(ngModel)]="viewModel.rawDataDefault"
                        #timestampInputRaw="ngModel"
                        (blur)="validateTimestampRaw(timestampInputRaw)">
                        <mat-hint *ngIf="!timestampInputRaw.errors?.invalidTimestamp" style="margin-left: -15px;">yyyy-MM-dd HH:mm:ss</mat-hint>
                        <mat-error *ngIf="timestampInputRaw.errors?.invalidTimestamp">{{ timestampErrorRaw }}</mat-error>
                    </mat-form-field>
                </div>  
            </div>
          </div>
      </div>
    <div style="margin-right: 10px;margin-left: -15px;">
      <div>
        <span style="font-size: 12px; font-weight: 500; color: rgba(255,255,255,0.7); display: inline-block;">
            Placeholder Column Defaults
        </span>
        <div style="display: flex; justify-content: space-between;">
            <div style="flex: 1;margin-right: 10px;">    
                <div>
                    <mat-form-field  style="width: 180px;">
                        <mat-label>String/Object</mat-label>
                        <input matInput placeholder="Empty" type="text" [(ngModel)]="viewModel.stringObjectDefVal">
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field  style="width: 180px;">
                        <mat-label>Timestamp</mat-label>
                        <input matInput placeholder="1970-01-01 00:00:00" type="text" [(ngModel)]="viewModel.timestampDefVal"
                        #timestampInput="ngModel"
                        (blur)="validateTimestamp(timestampInput)">
                        <mat-hint *ngIf="!timestampInput.errors?.invalidTimestamp" style="margin-left: -15px;">
                            yyyy-MM-dd HH:mm:ss</mat-hint>
                        <mat-error *ngIf="timestampInput.errors?.invalidTimestamp">{{ timestampError }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field  style="width: 180px;margin-top: 10px;">
                        <mat-label>Boolean</mat-label>
                        <!-- <input matInput placeholder="False" type="text" [(ngModel)]="viewModel.booleanDefVal"> -->
                         <mat-select [(ngModel)]="viewModel.booleanDefVal" placeholder="Boolean">
                            <mat-option value="False">False</mat-option>
                            <mat-option value="True">True</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>    
            <div style="flex: 1;">    
                <div>
                    <mat-form-field  style="width: 120px;">
                        <mat-label>Integer</mat-label>
                        <input matInput placeholder="Integer" type="text" [(ngModel)]="viewModel.integerDefVal"
                        inputmode="numeric"
                        (keypress)="allowOnlyIntegers($event)"
                        (paste)="validatePaste($event)"
                        autocomplete="off">
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field  style="width: 120px;">
                        <mat-label>Float</mat-label>
                        <input matInput placeholder="Float" type="text" [(ngModel)]="viewModel.floatDefVal" 
                        (keypress)="allowOnlyFloats($event)"
                        (paste)="validateFloatPaste($event)"
                        inputmode="decimal"
                        autocomplete="off">
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field  style="width: 120px;margin-top: 10px;">
                        <mat-label>Duration</mat-label>
                        <input matInput placeholder="Duration" type="text" [(ngModel)]="viewModel.durationDefVal"
                        (keypress)="allowOnlyPositiveFloats($event)"
                        (paste)="validatePositiveFloatPaste($event)"
                        inputmode="decimal"
                        autocomplete="off">
                    </mat-form-field>
                </div>
            </div>  
        </div>
      </div>
    </div>  
  </div>


